import sum from "lodash/sum";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { EstimatedDeliveryDay, EstimatedDeliveryDayData, Item, RibbonProps, Shipping } from "./Models";
import { getDropShipEta } from "../FullCheckout/Shared/Models/CartProduct";
export const formatOrFreePrice = (price: number) => {
  if (price === 0) {
    return "FREE";
  }
  return formatAsCurrency.formatIfUndefined(price);
};
export const formatOrFreeTotal = (item: Item, quantity: string) => {
  if (item.price === 0) {
    return "FREE";
  }
  return formatAsCurrency.formatIfUndefined(calculateTotalItemPrice(item, quantity));
};
export const calculateItemQuantity = (item: Item, qty: string | undefined = undefined) => {
  if (qty === "" || qty === "0") {
    return qty;
  }
  if (item) {
    if (item.subItems && (item.cartGroupType === "quantityDiscount" || item.cartGroupType === "accessoryQuantityDiscount")) {
      return item.subItems.filter(sub => sub.cartGroupType === "quantityDiscount" || item.cartGroupType === "accessoryQuantityDiscount").reduce((acc, cv) => {
        return acc + cv.qty;
      }, item.qty);
    }
    return item.qty;
  }
  return 0;
};
export const calculateTotalItemPrice = (item: Item, qty: string): number => {
  if (item) {
    const basePrice = qty === "" || item.cartGroupType === "quantityDiscount" || item.cartGroupType === "accessoryQuantityDiscount" ? item.qty * item.price : Number(qty) * item.price;

    // An item's subitems may not always be the same qty as the main item.
    return item.subItems && item.subItems.length > 0 ? basePrice + sum(item.subItems.map(i => calculateTotalItemPrice(i, i.qty.toString()))) : basePrice;
  }
  return 0;
};
export const getShouldEstimateDeliveryDates = (shipping: Readonly<Shipping> | undefined, shouldItemEstimateDeliveryDate: boolean): boolean => {
  return (shipping?.shouldestimatedeliverydates ?? false) && shouldItemEstimateDeliveryDate;
};
export function GetEstimatedDeliveryDayLineItemText(shippingMethodName: string, shippingMethodDeliveryData: EstimatedDeliveryDayData | undefined, item: {
  itemNumberId: number;
  shouldDisplayDropShipEta: boolean;
  estimatedShipTimeMessage: string;
}): string | undefined {
  const dropShipEta = getDropShipEta(item.estimatedShipTimeMessage, item.shouldDisplayDropShipEta);
  const isGround = shippingMethodName === "Ground";
  const isSecondDayAir = shippingMethodName === "Second Day Air";
  const isNextDayAir = shippingMethodName === "Next Day Air";
  const isCommonCarrier = shippingMethodName.includes("Common");
  if (dropShipEta.length === 0 && !item.shouldDisplayDropShipEta && shippingMethodDeliveryData) {
    if (isGround) {
      return GetShippingMethodDataMsg(item.itemNumberId, shippingMethodDeliveryData.ground);
    } else if (isCommonCarrier) {
      return GetShippingMethodDataMsg(item.itemNumberId, shippingMethodDeliveryData.commonCarrier);
    } else if (isSecondDayAir) {
      return GetShippingMethodDataMsg(item.itemNumberId, shippingMethodDeliveryData.secondDayAir);
    } else if (isNextDayAir) {
      return GetShippingMethodDataMsg(item.itemNumberId, shippingMethodDeliveryData.nextDayAir);
    }
  }
  return "";
}
function GetShippingMethodDataMsg(itemNumberId: number, shippingMethodData: {
  [key: string]: EstimatedDeliveryDay;
}): string {
  if (shippingMethodData?.[itemNumberId]?.transitdays && shippingMethodData?.[itemNumberId]?.isvalid) {
    return shippingMethodData[itemNumberId]?.text ?? "";
  }
  return "";
}
export const getRibbonData = (item: Item): RibbonProps => {
  return {
    isWebplusEligible: item.isWebplusEligible,
    hasWebstaurantPlusDiscountedShipping: item.hasWebstaurantPlusDiscountedShipping,
    isFreeShipping: item.isFreeShipping === 1,
    isCommonCarrier: item.isCommonCarrier === 1,
    isTooLargeForLiftgate: item.isTooLargeForLiftgate,
    isSpecialOrder: item.isSpecialOrder === 1,
    isUnavailableItem: item.isUnavailableItem === 1,
    isQuoteItem: item.isQuoteItem === 1,
    isAutoReorderedItemNearingReorder: item.isAutoReorderedItemNearingReorder,
    perishableType: item.perishableType ?? "",
    estimatedShipTimeMessage: item.estimatedShipTimeMessage,
    shouldDisplayDropShipEta: item.shouldDisplayDropShipEta,
    minBuy: item.minBuy,
    mustBuy: item.mustBuy,
    purchasingGroupId: item.purchasingGroupId,
    purchasingGroupMinBuy: item.purchasingGroupMinBuy,
    purchasingGroupMustBuy: item.purchasingGroupMustBuy
  };
};